module.exports = __webpack_public_path__ + "img/Wolfgang Schramml.6cd9a457.jpg";